import axios from "axios";
import { makeObservable, observable, when } from "mobx";
import { FrontendConfiguration } from "../FrontendConfiguration";

export class TransportService {
  configuration: FrontendConfiguration;

  constructor() {
    this.configuration = {};

    makeObservable(this, {
      configuration: observable,
    });

    void this.fetchConfiguration();
  }

  private async fetchConfiguration() {
    const configurationResult = await fetch(
      "/conf/frontendConfiguration.json",
      {
        method: "GET",
        credentials: "include",
        mode: "no-cors",
      }
    );

    const configurationJson = await configurationResult.json();
    this.configuration = configurationJson.configuration;
  }

  async get(url: string): Promise<any> {
    await when(() => this.configuration.backendUrl !== undefined);

    return axios.get(`${this.configuration.backendUrl}${url}`);
  }

  async getWithToken(url: string, token: string | undefined): Promise<any> {
    await when(() => this.configuration.backendUrl !== undefined);

    return axios.get(`${this.configuration.backendUrl}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  async deleteWithToken(url: string, token: string): Promise<any> {
    await when(() => this.configuration.backendUrl !== undefined);

    return axios.delete(`${this.configuration.backendUrl}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  async postWithToken(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
    url: string,
    token: string,
    signal?: AbortSignal
  ): Promise<any> {
    await when(() => this.configuration.backendUrl !== undefined);

    return axios.post(`${this.configuration.backendUrl}${url}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal: signal,
    });
  }

  async putWithToken(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
    url: string,
    token: string | undefined
  ): Promise<any> {
    await when(() => this.configuration.backendUrl !== undefined);

    return axios.put(`${this.configuration.backendUrl}${url}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  }
}
